import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import { FloatMessageProvider } from './components/Providers/FloatMessage'


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <FloatMessageProvider>
      <App />
    </FloatMessageProvider>
  </React.StrictMode>
)